import type { HomeCity } from '../types';
import { CityIcon } from '../utils/cityCovers';

interface CitiesSectionProps {
  cities: HomeCity[];
  activeSlug: string | null;
  onSelect: (slug: string) => void;
}

export function CitiesSection({ cities, activeSlug, onSelect }: CitiesSectionProps) {
  if (cities.length === 0) return null;

  return (
    <section className="section" id="cities">
      <div className="section-head">
        <div>
          <h2>Explore por Cidade</h2>
          <p>Descubra experiências perto de onde você quer ir.</p>
        </div>
      </div>
      <div className="cities-grid">
        {cities.map((city) => {
          const isActive = activeSlug === city.slug;
          return (
            <a
              key={city.slug}
              className={`city-tile${isActive ? ' city-tile--active' : ''}`}
              href={`/?city=${encodeURIComponent(city.slug)}`}
              aria-label={`${city.name} · ${city.experienceCount} experiência${city.experienceCount === 1 ? '' : 's'}`}
              aria-pressed={isActive}
              onClick={(e) => {
                if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
                e.preventDefault();
                onSelect(city.slug);
              }}
            >
              <span className="city-tile__icon" aria-hidden="true">
                <CityIcon slug={city.slug} size={28} />
              </span>
              <span className="city-tile__name">{city.name}</span>
              <span className="city-tile__count">
                {city.experienceCount} experiência{city.experienceCount === 1 ? '' : 's'}
              </span>
            </a>
          );
        })}
      </div>
    </section>
  );
}
